import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { classNamesFor } from '../utils/classNames';
import { getTrophyTypeImageSrc } from '../Trophy';
var cx;
/**
 * The TrophyTotals component shows the counts of all platinum, gold, silver and bronze trophies
 *
 * ## Composed of
 * - [Media](../Media/README.md)
 *
 * ## Related Components
 * - [Trophy](../Trophy/README.md)
 * - [TrophyOverview](../TrophyOverview/README.md)
 *
 * ## Usage
 *
 *```jsx
 * <TrophyTotals
 *   platinumCount={2}
 *   goldCount={8}
 *   silverCount={19}
 *   bronzeCount={11}
 * />
 * ```
 *
 * ## Props
 */

var TrophyTotals = function TrophyTotals(props) {
  var qa = props.qa,
      className = props.className,
      platinumCount = props.platinumCount,
      goldCount = props.goldCount,
      silverCount = props.silverCount,
      bronzeCount = props.bronzeCount,
      size = props.size,
      layout = props.layout;

  var _TrophyTotals$getClas = TrophyTotals.getClassName({
    className: className,
    size: size,
    layout: layout
  }),
      root = _TrophyTotals$getClas.root,
      cell = _TrophyTotals$getClas.cell;

  return /*#__PURE__*/React.createElement("div", {
    "data-qa": qa,
    className: root,
    style: {
      minWidth: 200
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#platinumCount"),
    className: cell
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "image:".concat(getTrophyTypeImageSrc('platinum')),
    size: size
  }), platinumCount), /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#goldCount"),
    className: cell
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "image:".concat(getTrophyTypeImageSrc('gold')),
    size: size
  }), goldCount), /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#silverCount"),
    className: cell
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "image:".concat(getTrophyTypeImageSrc('silver')),
    size: size
  }), silverCount), /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#bronzeCount"),
    className: cell
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "image:".concat(getTrophyTypeImageSrc('bronze')),
    size: size
  }), bronzeCount));
};

TrophyTotals.useClassNames = function (classNames) {
  TrophyTotals.classNames = classNames;
};

TrophyTotals.getClassName = function (_ref) {
  var className = _ref.className,
      layout = _ref.layout;
  return {
    root: cx('psw-trophy-totals', 'psw-s-num', 'psw-l-line-repel', className),
    cell: cx(layout === 'v' ? 'psw-l-stack-center' : 'psw-l-line-left')
  };
};

TrophyTotals.defaultProps = {
  qa: '',
  className: '',
  platinumCount: 0,
  goldCount: 0,
  silverCount: 0,
  bronzeCount: 0,
  layout: 'h',
  size: 's'
};
TrophyTotals.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The total number of platinum trophies earned
   */
  platinumCount: PropTypes.number,

  /**
   * The total number of gold trophies earned
   */
  goldCount: PropTypes.number,

  /**
   * The total number of silver trophies earned
   */
  silverCount: PropTypes.number,

  /**
   * The total number of bronze trophies earned
   */
  bronzeCount: PropTypes.number,
  layout: PropTypes.oneOf(['h', 'v']),
  size: PropTypes.oneOf(['s', 'l'])
};
cx = classNamesFor(TrophyTotals);
export default TrophyTotals;